import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportEvent from "./AbstractPeriodReportEvent.js";

/**
 * A `WithdrawEvent` is logged when a published period report withdrawn by an accountant.
 * There is only one such event in a period report event log and it can only come after
 * a PublishEvent.
 */
export default class WithdrawEvent extends AbstractPeriodReportEvent {
	isStatusEvent() {
		return true;
	}

	isWithdraw() {
		return true;
	}

	getLabel() {
		return _("Withdrawn");
	}

	static getType() {
		return "Withdraw";
	}
}
